import { Component, computed, inject, model } from '@angular/core';
import { Avatar } from '../../shared/avatar/avatar';
import { NavigationButton } from '../../navigation-button/navigation-button';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  tablerHelp,
  tablerRocket,
  tablerMessages,
  tablerLayoutSidebarLeftCollapse,
  tablerLayoutSidebarLeftExpand,
} from '@ng-icons/tabler-icons';
import { UserService } from '../../services/user-service/user.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NeedHelpService } from '../../services/need-help.service';

@Component({
  selector: 'nav-footer',
  template: `
    <div class="container" [class.collapsed]="isCollapsed()">
      <div class="links">
        <navigation-button
          href="/get-started"
          label="Get Started"
          icon="tablerRocket"
          [showIconOnly]="isCollapsed()"
        />
        <navigation-button
          href="/faq"
          label="FAQ"
          icon="tablerMessages"
          [showIconOnly]="isCollapsed()"
        />
        <button
          class="footer-btn"
          [class.icon-only]="isCollapsed()"
          type="button"
          (click)="needHelp.open()"
        >
          <ng-icon name="tablerHelp" size="18px" strokeWidth="1.5" />
          @if (!isCollapsed()) {
            <span>Need Help?</span>
          }
        </button>
        <button
          class="footer-btn"
          [class.icon-only]="isCollapsed()"
          type="button"
          (click)="toggleSidebar()"
        >
          @if (isCollapsed()) {
            <ng-icon name="tablerLayoutSidebarLeftExpand" size="18px" strokeWidth="1.5px" />
          } @else {
            <ng-icon name="tablerLayoutSidebarLeftCollapse" size="18px" strokeWidth="1.5px" />
            <span>Collapse</span>
          }
        </button>
      </div>
      @if (isCollapsed()) {
        <avatar [name]="name()" [src]="userPhotoSrc()" />
      } @else {
        <div class="user">
          <avatar [name]="name()" [src]="userPhotoSrc()" />
          <div class="user-details">
            <span class="user-name">{{ name() }}</span>
            <span class="user-department">{{ department() }}</span>
          </div>
        </div>
      }
    </div>
  `,
  styleUrl: './nav-footer.scss',
  imports: [Avatar, NavigationButton, NgIcon],
  providers: [
    provideIcons({
      tablerRocket,
      tablerHelp,
      tablerMessages,
      tablerLayoutSidebarLeftCollapse,
      tablerLayoutSidebarLeftExpand,
    }),
  ],
})
export class NavFooter {
  userService = inject(UserService);
  private sanitizer = inject(DomSanitizer);

  userDetails = this.userService.getUserDetails().data;
  userPhoto = this.userService.getUserPhoto();
  userPhotoSrc = computed(() => {
    if (this.userPhoto.isSuccess()) {
      const blobData = this.userPhoto.data(); // Safe read
      const objectUrl = URL.createObjectURL(blobData);
      return this.sanitizer.bypassSecurityTrustUrl(objectUrl);
    }

    return undefined;
  });

  isCollapsed = model.required<boolean>();
  needHelp = inject(NeedHelpService);

  name = computed(() => {
    return this.userDetails()?.displayName ?? '-';
  });
  department = computed(() => {
    return this.userDetails()?.department ?? '-';
  });

  toggleSidebar = () => {
    console.log('tt');
    if (this.isCollapsed()) {
      this.isCollapsed.set(false);
    } else {
      this.isCollapsed.set(true);
    }
  };
}
